/*
 * This file is part of glowingblue/newvigation.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat, Gianni Guida.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import IndexPage from 'flarum/forum/components/IndexPage';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import Search from 'flarum/forum/components/Search';

export default class NavElements extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	oncreate(vnode) {
		super.oncreate(vnode);

		this.$('.Header-controls li a').each((i, item) => {
			try {
				const url = new URL(item.href);
				const rootPath = url.pathname.split('/')[1];
				const currentRootPath = m.route.get().split('/')[1].split('?')[0];

				// Check if the url of the item points to an external link
				if (url.hostname !== new URL(app.forum.attribute('apiUrl')).hostname) {
					// In this case ignore it
					return;
				}

				// Special case for fof/pages links: activeness is already handled by default
				// Handling it here would set all links to all pages as active no matter what page is actually active.
				if (rootPath === 'p') {
					return;
				}

				let isActive = false;
				if (rootPath === currentRootPath) {
					isActive = true;
				}
				if (rootPath === 'all' && (currentRootPath === 't' || currentRootPath === 'd')) {
					isActive = true;
				}
				if (rootPath === 'users' && currentRootPath === 'u') {
					isActive = true;
				}
				if (isActive) {
					$(item).addClass('active');
				}
			} catch (e) {}
		});
	}

	view() {
		return (
			<div class="NavElements">
				<div class="container NavElements-main">
					<ul className="Header-controls">{listItems(this.items().toArray())}</ul>
				</div>
				<div className="NavElements-mobile-controls">
					<ul className="Header-controls">{listItems(this.mobileItems().toArray())}</ul>
				</div>
			</div>
		);
	}

	/**
	 * Build an item list for the controls.
	 *
	 * @return {ItemList}
	 */
	items() {
		const items = new ItemList();

		items.add('search', <Search state={app.search} />, 500);

		// put back the original items
		const { origItems } = this.attrs;
		items.merge(origItems);
		// and add the navigation links (coming from the IndexPage component)
		const navItems = IndexPage.prototype.removedNavItems();
		items.merge(navItems);

		return items;
	}

	mobileItems() {
		const items = new ItemList();

		// Insert the original items for the HeaderSecondary component
		const origItems = HeaderSecondary.prototype.items();
		items.merge(origItems);

		items.remove('search');

		// Rearrange the items by changing their priority

		// Put session dropdown at the top of the list
		if (items.has('session')) {
			items.setPriority('session', 100);
		}

		// Then put the notification below
		if (items.has('notifications')) {
			items.setPriority('notifications', 90);
		}

		// Push up Drafts
		if (items.has('Drafts')) {
			items.setPriority('Drafts', 50);
		}

		// Put locale dropdown at the bottom (very low priority)
		if (items.has('locale')) {
			items.setPriority('locale', -100);
		}

		return items;
	}
}
